import NanoBanner from 'honeydew/NanoBanner';
import { punctuateText } from 'utils/globalUtils';

import { SignupPromoTermsModal } from '../SignupNanoBanner/SignupPromoTermsModal';

/**
 * @component CustomerPromoNanoBanner
 *
 * Renders a customer promo <NanoBanner /> with a promo code and terms and conditions.
 *
 * See useCustomerPromoNanoBanner() hook in this directory, which
 * provides data and conditional rendering logic.
 *
 * @param {Object} props
 * @param {Function} props.handleDismiss - Function to handle dismissing the banner
 * @param {Object} props.promoCodeData - Data for the promo code
 * @param {Function} props.setShowPromoTermsModal
 * @param {boolean} props.showPromoTermsModal
 */
export function CustomerPromoNanoBanner({ handleDismiss, promoCodeData, setShowPromoTermsModal, showPromoTermsModal }) {
    const nanobarText = promoCodeData?.nanobarText;
    const nanobarTerms = promoCodeData?.nanobarTerms;

    const punctuatedNanobarText = punctuateText(nanobarText);

    return (
        <>
            <SignupPromoTermsModal
                showPromoTermsModal={showPromoTermsModal}
                setShowPromoTermsModal={setShowPromoTermsModal}
                termsAndConditions={nanobarTerms}
            />
            <NanoBanner
                boldCopy={punctuatedNanobarText}
                link="Terms"
                onClick={() => setShowPromoTermsModal(true)}
                handleDismiss={handleDismiss}
                data-optimizely-id="customer-promo-nano-banner"
            />
        </>
    );
}
